import { render, staticRenderFns } from "./AdvUpload.vue?vue&type=template&id=313747a4&scoped=true"
import script from "./AdvUpload.vue?vue&type=script&lang=js"
export * from "./AdvUpload.vue?vue&type=script&lang=js"
import style0 from "./AdvUpload.vue?vue&type=style&index=0&id=313747a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313747a4",
  null
  
)

export default component.exports